import { Injectable, Optional } from '@angular/core';
import { BrowserService } from '../services/browser.service';

export type Environment = 'local' | 'dev' | 'test' | 'production';
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public apiEndpoint: string;
  public socketEndpoint: string;
  public authClientID: string;
  public authDomain: string;
  public intercomAppId: string;
  public assetsEndpoint: string;
  public filesEndpoint: string;
  public optimizeId: string;
  public stripePublishableKey: string;
  public customerIoSiteId: string;
  public env: Environment;
  public origin: string;
  public tenantPathFromDomain: string;
  public gtmWorkspaceId: string;
  public gtmEnvironmentExtra = '';
  public segmentKey: string;
  public isTenantDomain: boolean;
  public customDomainCnameValue: string;
  public lightroomAuthClientId: string;

  constructor(@Optional() private browserService: BrowserService) {
    this.loadConfig();
  }

  private loadConfig() {
    this.env = this.browserService?.getEnv() || 'local';
    this.origin = this.browserService?.getOrigin() || 'http://localhost:4200';
    this.tenantPathFromDomain = this.browserService?.getTenantPath();

    if (this.env !== 'local') {
      console.debug('env:', this.env, 'origin:', this.origin);
    }

    if (this.env === 'local') {
      this.customDomainCnameValue = 'domains.dev.picflow.com';
      this.authDomain = 'picflow-dev.eu.auth0.com';
      this.authClientID = 'XNuiOiftOADVzw37gDMAypXZtNql1LFW';
      this.apiEndpoint = 'https://api.dev.picflow.io/v1';
      this.socketEndpoint = 'wss://api.dev.picflow.io';
      this.assetsEndpoint = 'https://assets.dev.picflow.io';
      this.filesEndpoint = 'https://files.dev.picflow.io';
      this.intercomAppId = 'e6ygvgd5';
      this.optimizeId = 'OPT-KCHSFLS';
      this.stripePublishableKey = 'pk_test_DryYoD7xsvd3p16oEn1s3pkJ00MLYT9HqZ';
      this.customerIoSiteId = '5ca3ffa72c4602a525a6';
      this.lightroomAuthClientId = '9dPTSMUWvb7O5fg1QoTRqpYfTM9Eu3yB';
    } else if (this.env === 'dev') {
      this.customDomainCnameValue = 'domains.dev.picflow.com';
      this.authDomain = 'picflow-dev.eu.auth0.com';
      this.authClientID = 'XNuiOiftOADVzw37gDMAypXZtNql1LFW';
      this.apiEndpoint = 'https://api.dev.picflow.io/v1';
      this.socketEndpoint = 'wss://api.dev.picflow.io';
      this.intercomAppId = 'e6ygvgd5';
      this.assetsEndpoint = 'https://assets.dev.picflow.io';
      this.filesEndpoint = 'https://files.dev.picflow.io';
      this.optimizeId = 'OPT-KCHSFLS';
      this.stripePublishableKey = 'pk_test_DryYoD7xsvd3p16oEn1s3pkJ00MLYT9HqZ';
      this.customerIoSiteId = '5ca3ffa72c4602a525a6';
      this.lightroomAuthClientId = '9dPTSMUWvb7O5fg1QoTRqpYfTM9Eu3yB';
    } else {
      // prod
      this.customDomainCnameValue = 'domains.picflow.com';
      this.authDomain = 'auth.picflow.com';
      this.authClientID = 'X7Qzik6m5hFZW0xT585EdTAa1nzfVFnH';
      this.apiEndpoint = 'https://api.picflow.io/v1';
      this.socketEndpoint = 'wss://api.picflow.io';
      this.intercomAppId = 'xh9h3015';
      this.assetsEndpoint = 'https://assets.picflow.io';
      this.filesEndpoint = 'https://files.picflow.io';
      this.optimizeId = 'OPT-WGS9DSW';
      this.stripePublishableKey = 'pk_live_NtSGaeAq8LDmOSSwHttWC3fZ00xG0iIQGE';
      this.customerIoSiteId = '3d7865fd575645fd048e';
      this.lightroomAuthClientId = 'dTWui4nAWMcK30LIA8ziAbVp3bTdqCHP';
    }

    if (this.browserService?.isTenantDomain()) {
      this.isTenantDomain = true;
      // Tenant domains (all environments)
      // this.gtmWorkspaceId = 'GTM-WGZK879';
      this.segmentKey = 'Gyn0nHaNp2QOZd5gTmGwr7UEDbHYqIff';

      if (this.env !== 'production') {
        this.segmentKey = 'xU9P5HdByaQsC0KdaTs66V8syQBVcFXQ';
        // On local, dev and test we load the "test" environment of this gtm workspace
        // this.gtmEnvironmentExtra = '&gtm_auth=OhS5S2g9p-Zeuff79f2x1Q&gtm_preview=env-3&gtm_cookies_win=x';
      }
    } else {
      this.isTenantDomain = false;
      // Main domain (all environments)
      this.gtmWorkspaceId = 'GTM-WNDQZLB';
      this.segmentKey = 'YHxKPC1js2rt2BEPcTENovSSr0OrPprc';

      if (this.env !== 'production') {
        this.segmentKey = 'aifMy2VQAvljDsfLW9TqVyRf1i2Kn50w';
        // On local, dev and test we load the "test" environment of this gtm workspace
        this.gtmEnvironmentExtra = '&gtm_auth=09Biw7nYhdMffj2og8K2fQ&gtm_preview=env-3&gtm_cookies_win=x';
      }
    }
  }
}
